import axios from 'axios';
import { getConfig } from '../../../config/apiConfig';
import authService from '../../../authentication/AuthorizeService';
import getLogger from '../../../utils/logger';

export const getSearchTypes = async (userId) => {
  let targetUserId = userId;
  if (!targetUserId) {
    targetUserId = await authService.getMaskedUserId();
  }
  const logger = getLogger();
  // Get auth header config
  const config = await getConfig();
  config.cache = true;
  const requestUrl = `api/search/getenabledsearchtypes`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data;
    })
    .catch((err) => {
      logger.error(err.response);
      return null;
    });
};

export const getSearchSuggestions = async (searchTerm, searchContext) => {
  if (
    searchTerm &&
    searchTerm.length >= 2 &&
    searchContext !== 'skillsoftcontent' &&
    searchContext !== 'kpointcontent'
  ) {
    const logger = getLogger();
    // Get auth header config
    const config = await getConfig();
    const requestUrl = `api/search/suggestions?searchTerm=${encodeURIComponent(
      searchTerm
    )}&contexts=${searchContext}`;
    return axios
      .get(requestUrl, config)
      .then(async (response) => {
        return response.data;
      })
      .catch((err) => {
        logger.error(err.response);
        return null;
      });
  }

  return null;
};
